import React from 'react';
import PlansCompareModal from '../shared/PlansCompareModal';

const PostRegisterPlansModal = ({ onClose }) => <PlansCompareModal onClose={onClose} />;

export default PostRegisterPlansModal;
